import { render, staticRenderFns } from "./shippingAddress.vue?vue&type=template&id=fdf78a64&scoped=true"
import script from "./shippingAddress.vue?vue&type=script&lang=js"
export * from "./shippingAddress.vue?vue&type=script&lang=js"
import style0 from "./shippingAddress.vue?vue&type=style&index=0&id=fdf78a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf78a64",
  null
  
)

export default component.exports